/**
 * Transforms a posting detail API model to an entity
 *
 * @param {import('../types/PostingDetails.api').IPostingDetailApiModel} model - API model
 * @returns {import('../types/PostingDetails').IPostingDetailsEntity} Entity
 */
const toPostingDetailsEntity = (model) => ({
  id: model.id,
  officeId: model.officeId,
  officeName: model.officeName,
  officeState: model.officeState,
  dsoCode: model.dsoCode,
  title: model.title,
  professionType: model.professionType,
  subProfession: model.subProfession,
  specialty: model.specialty,
  salaryRange: model.salaryRange,
  benefits: model.benefits,
  benefitsOther: model.benefitsOther,
  scheduleType: model.scheduleType,
  expectedDays: model.expectedDays,
  description: model.description,
  status: model.status,
  planId: model.planId,
  officePlanId: model.officePlanId,
  planName: model.planName,
  planStatus: model.planStatus,
  candidateCount: model.candidateCount,
  recruiterId: model.recruiterId,
  recruiterEmail: model.recruiterEmail,
  closedAt: model.closedAt,
  closedBy: model.closedBy,
  closedByName: model.closedByName,
  suspendedAt: model.suspendedAt,
  officeSelected: model.officeSelected,
  publishedAt: model.publishedAt,
  createdAt: model.createdAt,
  createdBy: model.createdBy,
  createdByName: model.createdByName,
  updatedAt: model.updatedAt,
  updatedBy: model.updatedBy,
  updatedByName: model.updatedByName,
});

/**
 * Posting Details Adapters
 * Provides transformation functions between API models and entities
 */
export const PostingDetailsAdapters = {
  toPostingDetailsEntity,
};
